import React, { useEffect, useRef, useState, useMemo } from "react";
import defaultImage from "../image/default_image.jpg";
import { Card, ListGroup } from "react-bootstrap";
import {
  handleCheckInfoWhenOut,
  handleSaveInfoWhenIn,
  recognizePlate,
} from "../services/api";

import { useSelector } from "react-redux";
import "./Scan.css";
import "./ModernScan.css";
import { base64ToBlob } from '../util/convertImgFile';
import { toast } from "react-toastify";
import { haandleGetParkingLotInfo, handleSaveInOutHistory } from "../services/employeeServices";
import { announceVehicleStatus } from "../util/vehicleAudio";
import { getRfidWebSocketUrl } from "../util/rfidWebSocket";

const defaultFacePlaceholder = `data:image/svg+xml;utf8,${encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" width="400" height="250" viewBox="0 0 400 250" fill="none">
  <rect width="400" height="250" fill="#0f172a" rx="10"/>
  <path d="M25 50 V 25 H 50" stroke="#38bdf8" stroke-width="3" stroke-linecap="round"/>
  <path d="M375 50 V 25 H 350" stroke="#38bdf8" stroke-width="3" stroke-linecap="round"/>
  <path d="M25 200 V 225 H 50" stroke="#38bdf8" stroke-width="3" stroke-linecap="round"/>
  <path d="M375 200 V 225 H 350" stroke="#38bdf8" stroke-width="3" stroke-linecap="round"/>
  <circle cx="200" cy="100" r="38" stroke="#475569" stroke-width="3" stroke-dasharray="6 6"/>
  <path d="M150 170 C 150 140, 250 140, 250 170" stroke="#475569" stroke-width="3" stroke-dasharray="6 6"/>
  <text x="200" y="210" fill="#94a3b8" font-family="system-ui, sans-serif" font-size="14" font-weight="600" text-anchor="middle">CHỜ CHỤP KHUÔN MẶT</text>
</svg>
`)}`;

const defaultPlatePlaceholder = `data:image/svg+xml;utf8,${encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" width="400" height="250" viewBox="0 0 400 250" fill="none">
  <rect width="400" height="250" fill="#0f172a" rx="10"/>
  <path d="M25 50 V 25 H 50" stroke="#38bdf8" stroke-width="3" stroke-linecap="round"/>
  <path d="M375 50 V 25 H 350" stroke="#38bdf8" stroke-width="3" stroke-linecap="round"/>
  <path d="M25 200 V 225 H 50" stroke="#38bdf8" stroke-width="3" stroke-linecap="round"/>
  <path d="M375 200 V 225 H 350" stroke="#38bdf8" stroke-width="3" stroke-linecap="round"/>
  <rect x="110" y="75" width="180" height="70" rx="8" stroke="#475569" stroke-width="3" stroke-dasharray="6 6"/>
  <text x="200" y="117" fill="#475569" font-family="system-ui, sans-serif" font-size="18" font-weight="bold" text-anchor="middle">59-X1 888.88</text>
  <text x="200" y="210" fill="#94a3b8" font-family="system-ui, sans-serif" font-size="14" font-weight="600" text-anchor="middle">CHỜ CHỤP BIỂN SỐ</text>
</svg>
`)}`;

const Scan = () => {
  const frontCameraRefs = [useRef(null)];
  const backCameraRefs = [useRef(null)];
  const frontStreamRef = useRef(null);
  const backStreamRef = useRef(null);
  const frontImages = useRef([]);
  const backImages = useRef([]);
  const stationaryId = useSelector(state => state.user.stationaryId)

  const [devices, setDevices] = useState([]);
  const [selectedDeviceId1, setSelectedDeviceId1] = useState('');
  const [selectedDeviceId2, setSelectedDeviceId2] = useState('');

  const [capturedImages, setCapturedImages] = useState([]);
  const [stationaryData, setStationaryData] = useState({});
  const [capacityChange, setCapacityChange] = useState(false);
  const [liveTimeStr, setLiveTimeStr] = useState(new Date().toLocaleTimeString('vi-VN'));
  const [isCarMode, setIsCarMode] = useState(false); // Nút switch Cổng Ô tô (bỏ qua quét mặt)

  useEffect(() => {
    const timer = setInterval(() => {
      setLiveTimeStr(new Date().toLocaleTimeString('vi-VN'));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const fetchParkingLotData = async () => {
      try {
        let res = await haandleGetParkingLotInfo(stationaryId);
        console.log('Fetched parking lot data: ', res);
        setStationaryData(res.DT); // vì backend trả về {EM, EC, DT}
        // setCapacityChange(!capacityChange);

      } catch (error) {
        console.error('Error fetching parking lot data:', error);
      }
    }
    fetchParkingLotData();
  }, [capacityChange]);




  useEffect(() => {
    async function getDevices() {
      try {
        // Xin quyền truy cập camera trước
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
          audio: false
        });

        // Dừng stream ngay sau khi có quyền
        stream.getTracks().forEach(track => track.stop());

        // Đợi một chút để browser cập nhật danh sách devices
        await new Promise(resolve => setTimeout(resolve, 100));

        const allDevices = await navigator.mediaDevices.enumerateDevices();
        // console.log('allDevices: ', allDevices);

        const videoDevices = allDevices.filter(
          (device) => device.kind === "videoinput" && device.deviceId && device.deviceId !== ""
        );

        // console.log('videoDevices found:', videoDevices.length, videoDevices);
        setDevices(videoDevices);

        if (videoDevices.length > 0) {
          // An toàn hơn: kiểm tra từng device trước khi gán
          setSelectedDeviceId1(videoDevices[0]?.deviceId || "");

          // Nếu có >= 2 camera thì dùng camera thứ 2, không thì dùng camera đầu
          if (videoDevices.length > 1) {
            setSelectedDeviceId2(videoDevices[1]?.deviceId || "");
          } else {
            setSelectedDeviceId2(videoDevices[0]?.deviceId || "");
          }
        }
      } catch (err) {
        console.error("Lỗi khi liệt kê thiết bị:", err);
      }
    }
    getDevices();
  }, []);
  const stopCameraStream = (streamRef, videoRefs) => {
    const stream = streamRef.current;
    if (stream) {
      stream.getTracks().forEach(track => track.stop());
      streamRef.current = null;
    }

    videoRefs.forEach(ref => {
      if (ref.current?.srcObject === stream) {
        ref.current.srcObject = null;
      }
    });
  };

  const setupStream = async (deviceId, videoRefs, streamRef, isCancelled) => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { deviceId: { exact: deviceId } },
        audio: false
      });

      if (isCancelled()) {
        stream.getTracks().forEach(track => track.stop());
        return;
      }

      streamRef.current = stream;
      videoRefs.forEach(ref => {
        if (ref.current) ref.current.srcObject = stream;
      });
    } catch (err) {
      if (!isCancelled()) {
        console.error("Lỗi khi truy cập camera:", err);
      }
    }
  };

  useEffect(() => {
    let cancelled = false;
    stopCameraStream(frontStreamRef, frontCameraRefs);

    if (selectedDeviceId1 && !isCarMode) {
      setupStream(selectedDeviceId1, frontCameraRefs, frontStreamRef, () => cancelled);
    }

    return () => {
      cancelled = true;
      stopCameraStream(frontStreamRef, frontCameraRefs);
    };
  }, [selectedDeviceId1, isCarMode]);

  useEffect(() => {
    let cancelled = false;
    stopCameraStream(backStreamRef, backCameraRefs);

    if (selectedDeviceId2) {
      setupStream(selectedDeviceId2, backCameraRefs, backStreamRef, () => cancelled);
    }

    return () => {
      cancelled = true;
      stopCameraStream(backStreamRef, backCameraRefs);
    };
  }, [selectedDeviceId2]);

  const handleCapture = (cardData) => {
    let captured = [];

    // 1. Chụp từ Cam Biển số (Back Cam)
    let backImgData = defaultPlatePlaceholder;
    if (backCameraRefs[0]?.current) {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = backCameraRefs[0].current.videoWidth || 640;
        canvas.height = backCameraRefs[0].current.videoHeight || 480;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(backCameraRefs[0].current, 0, 0, canvas.width, canvas.height);
        backImgData = canvas.toDataURL('image/png');
        if (backImages.current[0]) backImages.current[0].src = backImgData;
      } catch (e) {
        console.error("Lỗi chụp Cam Biển số:", e);
      }
    }

    // 2. Chụp từ Cam Khuôn mặt (Front Cam) - Nếu ẩn ở Chế độ Ô tô thì dùng ảnh Cam Biển số làm mồi
    let frontImgData = backImgData;
    if (!isCarMode && frontCameraRefs[0]?.current) {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = frontCameraRefs[0].current.videoWidth || 640;
        canvas.height = frontCameraRefs[0].current.videoHeight || 480;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(frontCameraRefs[0].current, 0, 0, canvas.width, canvas.height);
        frontImgData = canvas.toDataURL('image/png');
        if (frontImages.current[0]) frontImages.current[0].src = frontImgData;
      } catch (e) {
        console.error("Lỗi chụp Cam Khuôn mặt:", e);
      }
    }

    const timestamp = new Date().toLocaleString();
    captured = [
      { camFront1: frontImgData, timestamp },
      { camBack1: backImgData, timestamp }
    ];

    console.log("Ảnh đã chụp:", captured);
    setCapturedImages(captured);
    setCardData(cardData);
  };

  //RFID
  const [uid, setUid] = useState("");
  const [mode, setMode] = useState("");
  const [logs, setLogs] = useState([]);

  const [cardData, setCardData] = useState({});

  useEffect(() => {
    const ws = new WebSocket(getRfidWebSocketUrl());

    ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
      setUid(data.uid);
      setMode(data.mode);
      setLogs((prevLogs) => [...prevLogs, data]);
      console.log('data from card received: ', data);

      // setCardData(data);
      handleCapture(data)
      // handleSaveData()
    };

    ws.onclose = () => console.log("WebSocket disconnected");
    ws.onerror = (error) => console.log("WebSocket error:", error);

    return () => ws.close();
  }, []);

  // thay đổi thẻ và ảnh dc chụp thì gửi đi
  useEffect(() => {

    // console.log('useEFFECT2: ', cardData, capturedImages);
    if (cardData && capturedImages.length > 0) {
      // console.log('useEFFECT2: ', cardData, capturedImages);
      handleSaveData();
    }
  }, [cardData, capturedImages]);


  const handleSaveData = async () => {
    console.log('begin handleSaveData: ', cardData, '. imagecaptured: ', capturedImages);
    setUserDetached(undefined)

    if (cardData?.mode === "IN" || cardData?.mode === "OUT") {
      let formData = new FormData();
      formData.append("cardData", JSON.stringify(cardData));
      formData.append("imageFront", base64ToBlob(capturedImages[0].camFront1));
      formData.append("imageBack", base64ToBlob(capturedImages[1].camBack1));
      formData.append("stationCode", stationaryId);
      formData.append("isCarMode", isCarMode);
      // let dataSend = { cardData, capturedImages }
      console.log('run handleSaveData : ', stationaryId);

      // let response = cardData.mode === "IN" ?
      //     await handleSaveInfoWhenIn(dataSend)
      //     :
      //     await handleCheckInfoWhenOut(dataSend)

      let response = await recognizePlate(formData);

      console.log(`mode: ${cardData?.mode}. res: `, response);
      if (cardData?.mode === "IN" && +response?.EC === 1) {
        setUserDetached(response?.DT);
        setCapacityChange(!capacityChange);
        const pStr = response?.DT?.vehicleInfo?.[0]?.plate || response?.DT?.dataUser?.vehicleInfo?.[0]?.plate || response?.DT?.detachedPlate || "Chưa xác định";
        
        // Nếu là Khách Vãng Lai -> Cần bảo vệ thu tiền mặt/QR và bấm nút cho vào
        if (response?.DT?.isGuest || response?.DT?.requireManualConfirm) {
          setScanStatusAlert({
            type: 'warning',
            title: '🟡 XE KHÁCH VÃNG LAI - CHỜ BẢO VỆ DUYỆT VÀO',
            message: `Vui lòng THU TIỀN VÉ XE (Tiền mặt / Quét mã QR) và BẤM NÚT [DUYỆT CHO XE VÀO] màu xanh bên dưới để cho xe vào. Biển số xe: ${pStr}`,
            plate: pStr
          });
          toast.warning(`⚠️ Xe Khách vãng lai: Vui lòng thu tiền và bấm nút [DUYỆT CHO XE VÀO]!`);
          announceVehicleStatus("Xe khách vãng lai. Vui lòng thu tiền và duyệt cho xe vào.");
          return; // Giữ nguyên form chờ bảo vệ bấm nút duyệt
        }

        setScanStatusAlert({
          type: 'success',
          title: '🟢 XE VÀO THÀNH CÔNG',
          message: `Cho phép xe vào bãi. Biển số xe: ${pStr}`,
          plate: pStr
        });
        toast.success(`Xe vào thành công! Biển số: ${pStr}`);
        announceVehicleStatus("Xe vào thành công.");

      } else if (cardData?.mode === "OUT" && +response?.EC === 1) {
        setUserDetached(response?.DT);
        setCapacityChange(!capacityChange);
        const pStr = response?.DT?.detachedPlate || response?.DT?.existedPlate || response?.DT?.vehicleInfo?.[0]?.plate || "Chưa xác định";
        setScanStatusAlert({
          type: 'success',
          title: '🟢 XE RA THÀNH CÔNG',
          message: `Cho phép xe ra khỏi bãi. Biển số xe: ${pStr}`,
          plate: pStr
        });
        toast.success(`Xe ra thành công! Biển số: ${pStr}`);
        announceVehicleStatus("Xe ra thành công.");

      } else {
        setScanStatusAlert({
          type: 'danger',
          title: '🔴 QUÉT THẤT BẠI',
          message: response?.EM || 'Không nhận diện được biển số / dữ liệu không hợp lệ!',
          plate: null
        });
        toast.error(`${response?.EM || 'Quét thất bại'}`);
        announceVehicleStatus("Xử lý xe thất bại.");
      }
      await new Promise(resolve => setTimeout(resolve, 3000));
      setUserDetached(undefined);
      setCapturedImages([])
      setCardData({})
      // frontImages.current = [];
      // backImages.current = [];
      frontImages.current.forEach((img) => {
        if (img) img.src = defaultFacePlaceholder;
      });

      backImages.current.forEach((img) => {
        if (img) img.src = defaultPlatePlaceholder;
      });


    } else {            //TEST bằng cách bấm
      // alert("Thẻ không hợp lệ.");
      // console.log('thẻ không hợp lệ');
      // return;

      // Chuẩn bị dữ liệu gửi lên server
      if (capturedImages.length >= 2) {
        let formData = new FormData();
        // formData.append("cardData", JSON.stringify(cardData));
        formData.append("imageFront", capturedImages[0].camFront1);
        formData.append("imageBack", capturedImages[1].camBack1);
        console.log('formData before call api: ', formData);

        try {
          let result = await recognizePlate(formData); // Gửi file lên server
          console.log("Kết quả nhận diện biển số (môi trường test):", result);
        } catch (error) {
          console.error("Lỗi khi gửi dữ liệu nhận diện biển số:", error);
        }
      } else {
        console.warn("Không đủ ảnh trong mảng capturedImages để xử lý!");
      }

      return;
    }
  }

  const handleDeleteData = () => {
    setCardData({})
    setCapturedImages([])
  }

  //ấn ESC clear data
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        handleDeleteData();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);


  //END RFID

  // DATA USER AFTER DETACH
  const [userDetached, setUserDetached] = useState();
  const [isEditingPlate, setIsEditingPlate] = useState(false);
  const [editedPlate, setEditedPlate] = useState("");

  // Sync editedPlate when userDetached changes
  useEffect(() => {
    const plateFromDetached = userDetached?.dataUser?.vehicleInfo?.[0]?.plate || userDetached?.results?.[0]?.plate || "";
    setEditedPlate(plateFromDetached);
  }, [userDetached]);

  // Check if plate matches registered user's vehicles list
  const isPlateUnregistered = useMemo(() => {
    if (!userDetached || !editedPlate) return false;
    const userVehicles = userDetached?.dataUser?.userInfo?.vehicles || userDetached?.dataUser?.userInfo?.UserVehicles || [];
    if (!userVehicles || userVehicles.length === 0) return false;
    const match = userVehicles.some(v => (v.license_plate || v.plate || "").toUpperCase() === editedPlate.trim().toUpperCase());
    return !match;
  }, [userDetached, editedPlate]);

  // Manual Approve Entry/Exit Handler
  const handleManualApprove = async (overrideMode) => {
    const targetMode = overrideMode || (cardData?.mode === "OUT" ? "OUT" : "IN");
    const targetPlate = editedPlate || userDetached?.detachedPlate || userDetached?.vehicleInfo?.[0]?.plate || "";
    
    if (!targetPlate) {
      toast.error("Vui lòng nhập/kiểm tra biển số xe!");
      announceVehicleStatus("Xử lý xe thất bại. Vui lòng kiểm tra biển số.");
      return;
    }

    // Nếu lượt xe RA đã được backend xử lý & cập nhật slot tự động khi quẹt thẻ
    if (targetMode === "OUT" && (userDetached?.dataUser?.type === "OUT" || userDetached?.alreadySaved)) {
      toast.success("✅ Cho xe RA thành công!");
      announceVehicleStatus("Xe ra thành công.");
      setUserDetached(undefined);
      setCapturedImages([]);
      setCardData({});
      frontImages.current.forEach((img) => { if (img) img.src = defaultFacePlaceholder; });
      backImages.current.forEach((img) => { if (img) img.src = defaultPlatePlaceholder; });
      return;
    }
    try {
      const payload = {
        userData: {
          userInfo: userDetached?.dataUser?.userInfo || userDetached?.userInfo || { userCode: "GUEST_KHACH_VANGLAI", name: "Khách vãng lai" },
          vehicleInfo: [{ plate: targetPlate, vehicle: { type: "Xe máy" } }],
          timeIn: targetMode === "IN" ? new Date().toISOString() : (userDetached?.dataUser?.timeIn || new Date().toISOString()),
          timeOut: targetMode === "OUT" ? new Date().toISOString() : null,
          type: targetMode,
          stationId: stationaryId || "T"
        }
      };
      let res = await handleSaveInOutHistory(payload);
      if (res && res.EC === 1) {
        setCapacityChange(!capacityChange);
        toast.success(targetMode === "IN" ? "✅ Đã thu tiền & Duyệt xe VÀO thành công!" : "✅ Cho xe RA thành công!");
        announceVehicleStatus(targetMode === "IN" ? "Xe vào thành công." : "Xe ra thành công.");
        
        // Reset form sau khi duyệt thành công
        setUserDetached(undefined);
        setCapturedImages([]);
        setCardData({});
        setScanStatusAlert(null);
        frontImages.current.forEach((img) => { if (img) img.src = defaultFacePlaceholder; });
        backImages.current.forEach((img) => { if (img) img.src = defaultPlatePlaceholder; });
      } else {
        toast.error(res?.EM || "Lỗi khi xử lý cho xe vào/ra!");
        announceVehicleStatus("Xử lý xe thất bại.");
      }
    } catch (err) {
      console.error("Lỗi khi duyệt xe thủ công:", err);
      toast.error("Không thể xử lý cho xe vào/ra!");
      announceVehicleStatus("Xử lý xe thất bại.");
    }
  };

  const [scanStatusAlert, setScanStatusAlert] = useState(null);

  return (
    <div className="main-content" style={{ minHeight: "100vh", backgroundColor: "#f8f9fa", padding: "20px" }}>


      {/* Unified Modern Dashboard Header */}
      <div className="row mb-4">
        <div className="col-12">
          <div
            className="card border-0 shadow-lg overflow-hidden position-relative"
            style={{
              background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #312e81 100%)',
              borderRadius: '16px',
              color: '#ffffff'
            }}
          >
            {/* Decorative Glow Elements */}
            <div
              className="position-absolute rounded-circle opacity-25"
              style={{
                width: '280px',
                height: '280px',
                background: 'radial-gradient(circle, #6366f1 0%, transparent 70%)',
                top: '-80px',
                right: '-40px',
                pointerEvents: 'none'
              }}
            ></div>

            <div className="card-body p-4 position-relative z-1">
              <div className="row align-items-center gy-3">
                {/* Left Side: System Title & Station Info */}
                <div className="col-lg-5 col-md-12">
                  <div className="d-flex align-items-center gap-3">
                    <div
                      className="d-flex align-items-center justify-content-center rounded-4 p-3 shadow-sm"
                      style={{
                        background: 'rgba(255, 255, 255, 0.1)',
                        backdropFilter: 'blur(12px)',
                        border: '1px solid rgba(255, 255, 255, 0.2)'
                      }}
                    >
                      <i className="bi bi-shield-lock-fill text-warning fs-2"></i>
                    </div>
                    <div>
                      <h4 className="fw-bold mb-1 tracking-wide text-white">
                        HỆ THỐNG GIÁM SÁT XE RA VÀO
                      </h4>
                      <div className="d-flex align-items-center gap-2 text-white-50 small mt-1">
                        <span className="badge bg-success bg-opacity-25 text-success border border-success border-opacity-25 rounded-pill px-2 py-1">
                          <i className="bi bi-broadcast me-1"></i> Trực Tuyến
                        </span>
                        <span>| Trạm trực: <strong>{stationaryId || "T-01"}</strong></span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right Side: Guard & Realtime Station Metrics */}
                <div className="col-lg-7 col-md-12">
                  <div className="row g-2">
                    {/* Nhân viên trực */}
                    <div className="col-sm-4">
                      <div
                        className="p-3 rounded-3 h-100"
                        style={{
                          background: 'rgba(255, 255, 255, 0.07)',
                          backdropFilter: 'blur(8px)',
                          border: '1px solid rgba(255, 255, 255, 0.12)'
                        }}
                      >
                        <div className="text-white-50 small mb-1 d-flex align-items-center">
                          <i className="bi bi-person-badge text-info me-1"></i> Nhân Viên Trực
                        </div>
                        <div className="fw-bold text-white fs-6 text-truncate">
                          {stationaryData?.parkingLotName || "Nhân viên trạm đỗ"}
                        </div>
                      </div>
                    </div>

                    {/* Khu vực trực */}
                    <div className="col-sm-4">
                      <div
                        className="p-3 rounded-3 h-100"
                        style={{
                          background: 'rgba(255, 255, 255, 0.07)',
                          backdropFilter: 'blur(8px)',
                          border: '1px solid rgba(255, 255, 255, 0.12)'
                        }}
                      >
                        <div className="text-white-50 small mb-1 d-flex align-items-center">
                          <i className="bi bi-geo-alt-fill text-success me-1"></i> Khu Vực Đỗ
                        </div>
                        <div className="fw-bold text-info fs-6 text-truncate">
                          {stationaryData?.description || "Bãi Đỗ Xe Chính"}
                        </div>
                      </div>
                    </div>

                    {/* Đồng hồ thời gian thực */}
                    <div className="col-sm-4">
                      <div
                        className="p-3 rounded-3 h-100"
                        style={{
                          background: 'rgba(255, 255, 255, 0.07)',
                          backdropFilter: 'blur(8px)',
                          border: '1px solid rgba(255, 255, 255, 0.12)'
                        }}
                      >
                        <div className="text-white-50 small mb-1 d-flex align-items-center">
                          <i className="bi bi-clock-history text-warning me-1"></i> Thời Gian Thực
                        </div>
                        <div className="fw-bold text-warning fs-6">
                          {liveTimeStr}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Tiến độ */}
      {/* <div className="row mt-3">
        <div className="col-md-12">
          <div className="card" style={{ border: "none" }}>
            <div className="card-body">
              <div className="row">
                <h5>Tiến độ</h5>
                <div className="col-md-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    fill="blue"
                    className="bi bi-cursor-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M14.082 2.182a.5.5 0 0 1 .103.557L8.528 15.467a.5.5 0 0 1-.917-.007L5.57 10.694.803 8.652a.5.5 0 0 1-.006-.916l12.728-5.657a.5.5 0 0 1 .556.103z" />
                  </svg>
                  <span className="text-primary">Bước 1</span>
                  <br />
                  <p style={{ fontWeight: "500" }}>Chờ xác nhận</p>
                </div>
                <div className="col-md-1">
                  <hr />
                </div>
                <div className="col-md-2">
                  <span>Bước 2</span>
                  <br />
                  <p style={{ fontWeight: "500" }}>Xe trong bãi</p>
                </div>
                <div className="col-md-1">
                  <hr />
                </div>
                <div className="col-md-2">
                  <span className="">Bước 3</span>
                  <br />
                  <p style={{ fontWeight: "500" }}>Xe sẵn sàng ra ngoài</p>
                </div>
                <div className="col-md-1">
                  <hr />
                </div>
                <div className="col-md-2">
                  <span>Bước 4</span>
                  <br />
                  <p style={{ fontWeight: "500" }}>Xe đã ra ngoài</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* Side-by-Side Monitoring Dashboard */}
      <div className="row g-4 mt-1">
        {/* LEFT COLUMN (col-lg-7): LIVE CAMERAS & CONTROLS */}
        <div className="col-lg-7 col-md-12">
          {/* 1. Camera Feeds & AI Detection */}
          <div className="card border-0 shadow-sm rounded-4 mb-4">
            <div className="card-header bg-white border-0 pt-3 px-4 d-flex justify-content-between align-items-center flex-wrap gap-2">
              <h5 className="fw-bold mb-0 text-primary d-flex align-items-center gap-2">
                <i className="bi bi-cpu-fill text-primary fs-4"></i>
                Nhận diện Camera AI & Chụp Ảnh
              </h5>

              {/* NÚT SWITCH PHÂN LUỒNG CỔNG Ô TÔ / XE MÁY */}
              <div className="d-flex align-items-center gap-2 bg-light p-2 px-3 rounded-pill border shadow-sm">
                <i className={`bi ${isCarMode ? 'bi-car-front-fill text-primary' : 'bi-person-bounding-box text-success'} fs-5`}></i>
                <div className="form-check form-switch m-0 d-flex align-items-center gap-2">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="carModeSwitchToggle"
                    checked={isCarMode}
                    onChange={(e) => setIsCarMode(e.target.checked)}
                    style={{ width: "45px", height: "24px", cursor: "pointer" }}
                  />
                  <label
                    className={`form-check-label fw-bold small cursor-pointer m-0 ${isCarMode ? 'text-primary' : 'text-dark'}`}
                    htmlFor="carModeSwitchToggle"
                    style={{ userSelect: 'none', cursor: 'pointer' }}
                  >
                    {isCarMode ? 'CHẾ ĐỘ CỔNG Ô TÔ (Đã tắt cam mặt)' : 'CHẾ ĐỘ CỔNG XE MÁY (Bắt buộc quét mặt)'}
                  </label>
                </div>
              </div>
            </div>
            <div className="card-body p-3">
              {/* Camera Views Grid */}
              <div className="row g-3 mb-3">
                {/* CAM 1 (BÊN TRÁI): Plate - Biển số xe */}
                <div className={isCarMode ? "col-12" : "col-12 col-md-6"}>
                  <div className="bg-light p-2 rounded-3 border">
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <small className="fw-bold text-secondary">CAMERA BIỂN SỐ XE</small>
                      <span className="badge bg-danger rounded-circle p-1 animate-pulse"></span>
                    </div>
                    <div className="row g-2">
                      <div className="col-6">
                        <video
                          ref={backCameraRefs[0]}
                          autoPlay
                          muted
                          playsInline
                          className="bg-dark rounded-3 w-100 shadow-sm"
                          style={{ height: isCarMode ? "180px" : "140px", objectFit: "cover" }}
                        />
                      </div>
                      <div className="col-6">
                        <img
                          ref={(el) => (backImages.current[0] = el)}
                          src={defaultPlatePlaceholder}
                          alt="Plate"
                          className="rounded-3 w-100 border shadow-sm"
                          style={{ height: isCarMode ? "180px" : "140px", objectFit: "cover" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* CAM 2 (BÊN PHẢI): Face - Chỉ hiện khi ở Chế độ Xe máy */}
                {!isCarMode && (
                  <div className="col-12 col-md-6">
                    <div className="bg-light p-2 rounded-3 border">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <small className="fw-bold text-secondary">CAMERA KHUÔN MẶT</small>
                        <span className="badge bg-success rounded-circle p-1 animate-pulse"></span>
                      </div>
                      <div className="row g-2">
                        <div className="col-6">
                          <video
                            ref={frontCameraRefs[0]}
                            autoPlay
                            muted
                            playsInline
                            className="bg-dark rounded-3 w-100 shadow-sm"
                            style={{ height: "140px", objectFit: "cover" }}
                          />
                        </div>
                        <div className="col-6">
                          <img
                            ref={(el) => (frontImages.current[0] = el)}
                            src={defaultFacePlaceholder}
                            alt="Face"
                            className="rounded-3 w-100 border shadow-sm"
                            style={{ height: "140px", objectFit: "cover" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Camera Selectors & Capture Button */}
              <div className="p-3 bg-light rounded-3 d-flex flex-wrap align-items-center justify-content-between gap-2 border">
                <div className="d-flex align-items-center gap-2 flex-grow-1">
                  <small className="fw-semibold text-muted text-nowrap">Cam Biển số:</small>
                  <select
                    value={selectedDeviceId2}
                    onChange={(e) => setSelectedDeviceId2(e.target.value)}
                    className="form-select form-select-sm border-0 shadow-sm"
                  >
                    {devices.map((device, index) => (
                      <option key={`device2-${device.deviceId}`} value={device.deviceId}>
                        {device.label || `Camera ${index + 1}`}
                      </option>
                    ))}
                  </select>
                </div>

                {!isCarMode && (
                  <div className="d-flex align-items-center gap-2 flex-grow-1">
                    <small className="fw-semibold text-muted text-nowrap">Cam Khuôn mặt:</small>
                    <select
                      value={selectedDeviceId1}
                      onChange={(e) => setSelectedDeviceId1(e.target.value)}
                      className="form-select form-select-sm border-0 shadow-sm"
                    >
                      {devices.map((device, index) => (
                        <option key={`device1-${device.deviceId}`} value={device.deviceId}>
                          {device.label || `Camera ${index + 1}`}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                <button
                  onClick={handleCapture}
                  className="btn btn-primary btn-sm fw-bold px-3 shadow-sm d-flex align-items-center gap-1"
                >
                  <i className="bi bi-camera"></i> CHỤP
                </button>
              </div>
            </div>
          </div>



          {/* 3. Single Smart Action Button */}
          <div className="mb-4">
            {(() => {
              const isGuestPending = Boolean(userDetached?.isGuest || userDetached?.requireManualConfirm);
              const isActionActive = isGuestPending || isPlateUnregistered || Boolean(userDetached) || (editedPlate && editedPlate.trim() !== "");
              const currentMode = cardData?.mode === "OUT" ? "OUT" : "IN";

              if (!isActionActive) {
                return (
                  <button
                    type="button"
                    className="btn btn-secondary fw-bold w-100 py-3 shadow-sm d-flex align-items-center justify-content-center gap-2 opacity-50"
                    disabled
                    style={{ cursor: "not-allowed", fontSize: "16px", borderRadius: "12px" }}
                  >
                    <i className="bi bi-lock-fill fs-5"></i>
                    CHO XE VÀO / RA (TẮT - CHỜ QUẸT THẺ)
                  </button>
                );
              }

              if (currentMode === "OUT") {
                return (
                  <button
                    type="button"
                    className="btn btn-danger fw-bold w-100 py-3 shadow-lg d-flex align-items-center justify-content-center gap-2 text-uppercase"
                    style={{ fontSize: "17px", borderRadius: "12px" }}
                    onClick={() => handleManualApprove("OUT")}
                  >
                    <i className="bi bi-box-arrow-right fs-4"></i>
                    XÁC NHẬN CHO XE RA
                  </button>
                );
              }

              return (
                <button
                  type="button"
                  className="btn btn-success fw-bold w-100 py-3 shadow-lg d-flex align-items-center justify-content-center gap-2 text-uppercase border-3"
                  style={{
                    fontSize: "17px",
                    borderRadius: "12px",
                    boxShadow: isGuestPending ? "0 0 20px rgba(25, 135, 84, 0.8)" : undefined
                  }}
                  onClick={() => handleManualApprove("IN")}
                >
                  <i className="bi bi-box-arrow-in-right fs-4"></i>
                  {isGuestPending ? "🟢 DUYỆT CHO XE VÀO (ĐÃ THU TIỀN MẶT / QR)" : "XÁC NHẬN CHO XE VÀO"}
                </button>
              );
            })()}
          </div>

          {/* 4. RFID Reader Live Status Card */}
          <div className="card border-0 shadow-sm rounded-4">
            <div className="card-header bg-primary bg-opacity-10 border-0 pt-3 px-4 d-flex justify-content-between align-items-center">
              <span className="fw-bold text-primary d-flex align-items-center gap-2">
                <i className="bi bi-broadcast fs-5"></i> Trạng thái RFID Reader
              </span>
              <span className={`badge ${uid ? 'bg-success' : 'bg-warning text-dark'} px-3 py-2 rounded-pill`}>
                {uid ? '🟢 Đã nhận thẻ' : '🟡 Chờ quẹt thẻ...'}
              </span>
            </div>
            <div className="card-body p-3">
              <div className="row text-center align-items-center">
                <div className="col-6 border-end">
                  <small className="text-muted d-block text-uppercase fw-semibold mb-1">Mã Thẻ RFID (UID)</small>
                  <span className="fs-5 fw-bold text-dark font-monospace">{uid || "---"}</span>
                </div>
                <div className="col-6">
                  <small className="text-muted d-block text-uppercase fw-semibold mb-1">Chế độ (Mode)</small>
                  <span className={`fs-5 fw-bold ${mode === 'IN' ? 'text-success' : mode === 'OUT' ? 'text-danger' : 'text-secondary'}`}>
                    {mode ? (mode === 'IN' ? '🟢 VÀO (IN)' : '🔴 RA (OUT)') : "---"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT COLUMN (col-lg-5): VEHICLE, OWNER, CAPACITY & PAYMENT INFO */}
        <div className="col-lg-5 col-md-12">
          {/* 1. Vehicle & Owner Details Card */}
          <div className="card border-0 shadow-sm rounded-4 mb-4">
            <div className="card-header bg-white border-0 pt-3 px-4">
              <h5 className="fw-bold mb-0 text-primary d-flex align-items-center gap-2">
                <i className="bi bi-person-bounding-box text-primary fs-4"></i>
                Thông tin xe & chủ xe
              </h5>
            </div>
            <div className="card-body p-4">
              <div className="row g-3">
                {/* Biển số xe */}
                <div className="col-12">
                  <div className="p-3 bg-light rounded-3 border text-center">
                    <small className="text-muted fw-bold d-block mb-1 text-uppercase">Biển số xe nhận diện</small>
                    <div className="d-flex align-items-center justify-content-center gap-2">
                      <input
                        className="form-control form-control-lg border-0 bg-transparent text-center fw-bold fs-3 letter-spacing-1 text-primary py-0"
                        type="text"
                        value={editedPlate}
                        placeholder="--- CHỜ QUẸT THẺ ---"
                        onChange={(e) => setEditedPlate(e.target.value.toUpperCase())}
                        disabled={!isEditingPlate}
                      />
                      <button
                        type="button"
                        className={`btn ${isEditingPlate ? "btn-success" : "btn-outline-primary"} btn-sm rounded-circle p-2`}
                        title={isEditingPlate ? "Khóa/Lưu biển số" : "Chỉnh sửa biển số"}
                        onClick={() => setIsEditingPlate(!isEditingPlate)}
                      >
                        <i className={`bi ${isEditingPlate ? "bi-check-lg" : "bi-pencil-fill"}`}></i>
                      </button>
                    </div>
                  </div>
                </div>

                {/* Họ tên */}
                <div className="col-md-6">
                  <div className="p-2 bg-light rounded-3 border">
                    <small className="text-muted d-block small">HỌ VÀ TÊN</small>
                    <strong className="text-dark">
                      {userDetached ? (userDetached?.dataUser?.userInfo?.name || "Khách vãng lai") : "---"}
                    </strong>
                  </div>
                </div>

                {/* Loại xe */}
                <div className="col-md-6">
                  <div className="p-2 bg-light rounded-3 border">
                    <small className="text-muted d-block small">LOẠI XE</small>
                    <strong className="text-dark">
                      {userDetached ? (userDetached?.dataUser?.vehicleInfo?.[0]?.vehicle?.type || "Xe máy") : "---"}
                    </strong>
                  </div>
                </div>

                {/* Số điện thoại */}
                <div className="col-md-6">
                  <div className="p-2 bg-light rounded-3 border">
                    <small className="text-muted d-block small">SỐ ĐIỆN THOẠI</small>
                    <strong className="text-dark">
                      {userDetached?.dataUser?.userInfo?.phoneNumber || "---"}
                    </strong>
                  </div>
                </div>

                {/* Email */}
                <div className="col-md-6">
                  <div className="p-2 bg-light rounded-3 border">
                    <small className="text-muted d-block small">EMAIL</small>
                    <strong className="text-dark text-truncate d-block">
                      {userDetached?.dataUser?.userInfo?.email || "---"}
                    </strong>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 2. Payment & Checkout Info Card */}
          <div className="card border-0 shadow-sm rounded-4 mb-4">
            <div className="card-header bg-white border-0 pt-3 px-4">
              <h5 className="fw-bold mb-0 text-success d-flex align-items-center gap-2">
                <i className="bi bi-credit-card-2-back-fill text-success fs-4"></i>
                Thông tin thanh toán & Lượt xe
              </h5>
            </div>
            <div className="card-body p-4">
              <div className="row g-3">
                <div className="col-6">
                  <small className="text-muted d-block small">THỜI GIAN VÀO</small>
                  <strong className="text-dark">
                    {userDetached?.dataUser?.timeIn ? new Date(userDetached.dataUser.timeIn).toLocaleTimeString('vi-VN') : "---"}
                  </strong>
                </div>
                <div className="col-6">
                  <small className="text-muted d-block small">THỜI GIAN RA</small>
                  <strong className="text-dark">
                    {userDetached?.dataUser?.timeOut ? new Date(userDetached.dataUser.timeOut).toLocaleTimeString('vi-VN') : "---"}
                  </strong>
                </div>
                <div className="col-6">
                  <small className="text-muted d-block small">LOẠI KHÁCH HÀNG</small>
                  <strong className="text-dark">
                    {(() => {
                      if (!userDetached) return "---";
                      const uInfo = userDetached?.dataUser?.userInfo || userDetached?.userInfo;
                      if (!uInfo?.userId && !uInfo?.userCode) return "Khách vãng lai";
                      const pkg = uInfo?.activePackage;
                      const isPkgActive = pkg && ['ACTIVE', 'APPROVED', 'CANCELLED', 'CANCELED'].includes(String(pkg.status || '').toUpperCase()) && new Date(pkg.expiresAt) >= new Date();
                      return isPkgActive ? `Thành viên (${pkg.packageName || "ĐÃ ĐĂNG KÝ GÓI"})` : "Thành viên đăng ký";
                    })()}
                  </strong>
                </div>
                <div className="col-6">
                  <small className="text-muted d-block small">PHƯƠNG THỨC</small>
                  <strong className="text-dark">
                    {(() => {
                      if (!userDetached) return "---";
                      const uInfo = userDetached?.dataUser?.userInfo || userDetached?.userInfo;
                      if (!uInfo?.userId && !uInfo?.userCode) return "Tiền mặt / QR";
                      const pkg = uInfo?.activePackage;
                      const isPkgActive = pkg && ['ACTIVE', 'APPROVED', 'CANCELLED', 'CANCELED'].includes(String(pkg.status || '').toUpperCase()) && new Date(pkg.expiresAt) >= new Date();
                      return isPkgActive ? (pkg.packageName || "Gói xe thành viên (Miễn phí)") : "Trừ ví điện tử";
                    })()}
                  </strong>
                </div>
                <div className="col-12 pt-2 border-top">
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="fw-bold text-muted">TỔNG PHÍ ĐỖ XE:</span>
                    <span className={`fs-4 fw-bold ${userDetached?.dataUser?.userInfo?.activePackage && ['ACTIVE', 'APPROVED', 'CANCELLED', 'CANCELED'].includes(String(userDetached?.dataUser?.userInfo?.activePackage?.status || '').toUpperCase()) && new Date(userDetached?.dataUser?.userInfo?.activePackage?.expiresAt) >= new Date() ? 'text-success' : 'text-danger'}`}>
                      {(() => {
                        if (!userDetached) return "---";
                        const uInfo = userDetached?.dataUser?.userInfo || userDetached?.userInfo;
                        if (!uInfo?.userId && !uInfo?.userCode) return "4.000 VNĐ";
                        const pkg = uInfo?.activePackage;
                        const isPkgActive = pkg && ['ACTIVE', 'APPROVED', 'CANCELLED', 'CANCELED'].includes(String(pkg.status || '').toUpperCase()) && new Date(pkg.expiresAt) >= new Date();
                        return isPkgActive ? "0 VNĐ (Miễn phí gói)" : "4.000 VNĐ";
                      })()}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 3. Parking Lot Capacity Card */}
          <div className="card border-0 shadow-sm rounded-4">
            <div className="card-header bg-white border-0 pt-3 px-4">
              <h5 className="fw-bold mb-0 text-info d-flex align-items-center gap-2">
                <i className="bi bi-p-square-fill text-info fs-4"></i>
                Sức chứa bãi đỗ xe
              </h5>
            </div>
            <div className="card-body p-3">
              <div className="row text-center g-2">
                <div className="col-4">
                  <div className="p-2 bg-light rounded-3">
                    <small className="text-muted d-block">Tên bãi</small>
                    <strong className="text-dark">{stationaryData?.parkingLotName || "T"}</strong>
                  </div>
                </div>
                <div className="col-4">
                  <div className="p-2 bg-light rounded-3">
                    <small className="text-muted d-block">Chỗ trống</small>
                    <strong className="text-primary fs-5">{stationaryData?.capacity ?? "---"}</strong>
                  </div>
                </div>
                <div className="col-4">
                  <div className="p-2 bg-light rounded-3">
                    <small className="text-muted d-block">Trạng thái</small>
                    <strong className={`badge ${stationaryData?.capacity > 0 ? 'bg-success' : 'bg-danger'}`}>
                      {stationaryData ? (stationaryData.capacity <= 0 ? "Đầy chỗ" : "Còn chỗ") : "---"}
                    </strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Chỗ đã xóa */}
    </div>
  );
};

export default Scan;
